import template from './model-view.html';
import controller from './model-view.controller';


import './model-view.styl';

let modelViewComponent = {
  restrict: 'E',
  bindings: {
    mesh: '=',
    fileName: '='
  },
  template,
  controller
};

export default modelViewComponent;



// WEBPACK FOOTER //
// ./client/app/common/model-view/model-view.component.js